export const fonts = {
  'Aeroport': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Druk Text Cy': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Aeroport Medium': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Aeroport Light': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Aeroport Mono': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
}
